// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Normalize the [hidden] behavior (see https://meowni.ca/hidden.is.a.lie.html).
 *
 * The CSS class was needed for JSF, but nowadays it should be avoided in favor of the attribute.
 */
@layer defaults {
    :is([hidden],.hidden):where(:not([hidden="until-found"])) {
      display: none !important;
    }

    :is([hidden],.hidden):where([hidden="until-found"]) {
      content-visibility: hidden;
    }

    @supports not (content-visibility: hidden) {
  [hidden],
  .hidden {
      display: none !important;
  }
    }
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/hidden.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IAGI;MACE,wBAAwB;IAC1B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;EAVF;;MAWI,wBAAwB;EAE5B;IADE;AAEJ","sourcesContent":["/**\n * Normalize the [hidden] behavior (see https://meowni.ca/hidden.is.a.lie.html).\n *\n * The CSS class was needed for JSF, but nowadays it should be avoided in favor of the attribute.\n */\n@layer defaults {\n  [hidden],\n  .hidden {\n    &:where(:not([hidden=\"until-found\"])) {\n      display: none !important;\n    }\n\n    &:where([hidden=\"until-found\"]) {\n      content-visibility: hidden;\n    }\n\n    @supports not (content-visibility: hidden) {\n      display: none !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
